var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAccountsIds, getOrganizationsIds } from '../../../../backend/features/permissions';
// eslint-disable-next-line no-restricted-imports
import { getSystemRoles } from '../../../../backend/features/permissions/utils/getSystemRoles';
const typesOrder = ['modify', 'write', 'read'];
const sortAccordionItems = (items) => {
    return items.sort((a, b) => typesOrder.indexOf(a.permission) - typesOrder.indexOf(b.permission));
};
export const filterOutPermissions = (permissions, accountIds, organizationIds, systemRoles) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return {
        read: {
            accountIds: ((_a = permissions.read) === null || _a === void 0 ? void 0 : _a.accountIds.filter((id) => !accountIds.includes(id))) || [],
            organizationIds: ((_b = permissions.read) === null || _b === void 0 ? void 0 : _b.organizationIds.filter((id) => !organizationIds.includes(id))) || [],
            systemRoles: ((_c = permissions.read) === null || _c === void 0 ? void 0 : _c.systemRoles.filter((name) => !systemRoles.includes(name))) || [],
        },
        modify: {
            accountIds: ((_d = permissions.modify) === null || _d === void 0 ? void 0 : _d.accountIds.filter((id) => !accountIds.includes(id))) || [],
            organizationIds: ((_e = permissions.modify) === null || _e === void 0 ? void 0 : _e.organizationIds.filter((id) => !organizationIds.includes(id))) || [],
            systemRoles: ((_f = permissions.modify) === null || _f === void 0 ? void 0 : _f.systemRoles.filter((name) => !systemRoles.includes(name))) || [],
        },
        write: {
            accountIds: ((_g = permissions.write) === null || _g === void 0 ? void 0 : _g.accountIds.filter((id) => !accountIds.includes(id))) || [],
            organizationIds: ((_h = permissions.write) === null || _h === void 0 ? void 0 : _h.organizationIds.filter((id) => !organizationIds.includes(id))) || [],
            systemRoles: ((_j = permissions.write) === null || _j === void 0 ? void 0 : _j.systemRoles.filter((name) => !systemRoles.includes(name))) || [],
        },
    };
};
export const getAccordionItemsWithPermissions = (key, data, permissions) => {
    return data.map((row) => {
        var _a, _b, _c;
        const identifier = 'id' in row ? row.id : row.name;
        const readPermission = ((_a = permissions.read) === null || _a === void 0 ? void 0 : _a[key].includes(identifier)) && 'read';
        const writePermission = ((_b = permissions.write) === null || _b === void 0 ? void 0 : _b[key].includes(identifier)) && 'write';
        const modifyPermission = ((_c = permissions.modify) === null || _c === void 0 ? void 0 : _c[key].includes(identifier)) && 'modify';
        const documentPermission = modifyPermission || writePermission || readPermission || 'read';
        return Object.assign(Object.assign({}, row), { permission: documentPermission });
    });
};
export const getPermissionsUpdated = (currentPermissions, accountIds, organizationIds, selectedSystemRoles, newType) => {
    var _a, _b, _c;
    const permissionsReset = filterOutPermissions(currentPermissions, accountIds, organizationIds, selectedSystemRoles);
    const accountIdsReset = ((_a = permissionsReset[newType]) === null || _a === void 0 ? void 0 : _a.accountIds) || [];
    const organizationIdsReset = ((_b = permissionsReset[newType]) === null || _b === void 0 ? void 0 : _b.organizationIds) || [];
    const currentSystemRoles = ((_c = permissionsReset[newType]) === null || _c === void 0 ? void 0 : _c.systemRoles) || [];
    return Object.assign(Object.assign(Object.assign({}, currentPermissions), permissionsReset), { [newType]: {
            accountIds: [...accountIdsReset, ...accountIds],
            organizationIds: [...organizationIdsReset, ...organizationIds],
            systemRoles: [...currentSystemRoles, ...selectedSystemRoles],
        } });
};
export function fetchAccordionData(_a) {
    return __awaiter(this, arguments, void 0, function* ({ permissions, accountStorage, accountsFilter, canAccessAccounts, organizationStorage, initialFetch = false, systemRoleMap, }) {
        let accounts = [];
        let organizations = [];
        let systemRoleItems = [];
        let hiddenPermissions = {};
        const accountIds = getAccountsIds(permissions);
        const organizationIds = getOrganizationsIds(permissions);
        const systemRoles = getSystemRoles(permissions);
        const foundAccountsIds = [];
        const foundOrganizationIds = [];
        const foundSystemRoles = [];
        const userOrganizations = yield organizationStorage.list({ filter: [{ id: organizationIds, op: 'in' }] });
        if (accountIds.length && canAccessAccounts) {
            const accountData = yield accountStorage.list({ filter: accountsFilter.concat([{ id: accountIds, op: 'in' }]) });
            const accountDataMapped = accountData.rows.map((item) => ({ id: item.id, name: item.columns.displayName }));
            const accordionItemsWithPermissions = getAccordionItemsWithPermissions('accountIds', accountDataMapped, permissions);
            const accordionItemsSorted = sortAccordionItems(accordionItemsWithPermissions);
            foundAccountsIds.push(...accordionItemsSorted.map((acc) => acc.id));
            accounts = sortAccordionItems(accordionItemsWithPermissions);
        }
        if (organizationIds.length && userOrganizations.total) {
            const organizationData = [];
            organizationIds.forEach((item) => {
                const org = userOrganizations.rows.find((org) => org.id === item);
                if (org) {
                    organizationData.push({ id: org.id, name: org.columns.name });
                }
            });
            const accordionItemsWithPermissions = getAccordionItemsWithPermissions('organizationIds', organizationData, permissions);
            const accordionItemsSorted = sortAccordionItems(accordionItemsWithPermissions);
            foundOrganizationIds.push(...accordionItemsSorted.map((acc) => acc.id));
            organizations = sortAccordionItems(accordionItemsWithPermissions);
        }
        if (systemRoles.length) {
            const systemRolesMapped = Object.entries(systemRoleMap)
                .filter(([name]) => systemRoles.includes(name))
                .map(([name, role]) => ({ name, label: role.label }));
            const accordionItemsWithPermissions = getAccordionItemsWithPermissions('systemRoles', systemRolesMapped, permissions);
            const accordionItemsSorted = sortAccordionItems(accordionItemsWithPermissions);
            foundSystemRoles.push(...accordionItemsSorted.map((acc) => acc.name));
            systemRoleItems = sortAccordionItems(accordionItemsWithPermissions);
        }
        if (initialFetch) {
            hiddenPermissions = filterOutPermissions(permissions, foundAccountsIds, foundOrganizationIds, foundSystemRoles);
        }
        return {
            accounts,
            organizations,
            systemRoles: systemRoleItems,
            hiddenPermissions,
        };
    });
}
export const transformToDocumentPermissions = (accounts, organizations, systemRoles) => {
    const target = {};
    typesOrder.forEach((type) => {
        target[type] = {
            accountIds: accounts.filter((acc) => acc.permission === type).map((acc) => acc.id),
            organizationIds: organizations.filter((org) => org.permission === type).map((org) => org.id),
            systemRoles: systemRoles.filter((role) => role.permission === type).map((role) => role.name),
        };
    });
    return target;
};
export const mergePermissions = (permissions1, permissions2) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    return {
        read: {
            accountIds: [...(((_a = permissions1.read) === null || _a === void 0 ? void 0 : _a.accountIds) || []), ...(((_b = permissions2.read) === null || _b === void 0 ? void 0 : _b.accountIds) || [])],
            organizationIds: [...(((_c = permissions1.read) === null || _c === void 0 ? void 0 : _c.organizationIds) || []), ...(((_d = permissions2.read) === null || _d === void 0 ? void 0 : _d.organizationIds) || [])],
            systemRoles: [...(((_e = permissions1.read) === null || _e === void 0 ? void 0 : _e.systemRoles) || []), ...(((_f = permissions2.read) === null || _f === void 0 ? void 0 : _f.systemRoles) || [])],
        },
        modify: {
            accountIds: [...(((_g = permissions1.modify) === null || _g === void 0 ? void 0 : _g.accountIds) || []), ...(((_h = permissions2.modify) === null || _h === void 0 ? void 0 : _h.accountIds) || [])],
            organizationIds: [...(((_j = permissions1.modify) === null || _j === void 0 ? void 0 : _j.organizationIds) || []), ...(((_k = permissions2.modify) === null || _k === void 0 ? void 0 : _k.organizationIds) || [])],
            systemRoles: [...(((_l = permissions1.modify) === null || _l === void 0 ? void 0 : _l.systemRoles) || []), ...(((_m = permissions2.modify) === null || _m === void 0 ? void 0 : _m.systemRoles) || [])],
        },
        write: {
            accountIds: [...(((_o = permissions1.write) === null || _o === void 0 ? void 0 : _o.accountIds) || []), ...(((_p = permissions2.write) === null || _p === void 0 ? void 0 : _p.accountIds) || [])],
            organizationIds: [...(((_q = permissions1.write) === null || _q === void 0 ? void 0 : _q.organizationIds) || []), ...(((_r = permissions2.write) === null || _r === void 0 ? void 0 : _r.organizationIds) || [])],
            systemRoles: [...(((_s = permissions1.write) === null || _s === void 0 ? void 0 : _s.systemRoles) || []), ...(((_t = permissions2.write) === null || _t === void 0 ? void 0 : _t.systemRoles) || [])],
        },
    };
};
